export const MOVIES_PER_ROW = 6;
export const IMAGE_BASE_URL_W300 = "http://image.tmdb.org/t/p/w300";
export const IMAGE_BASE_URL_W500 = "http://image.tmdb.org/t/p/w500";
export const RESPONSIVE_COLUMN_CONFIG = {
  extraLarge: {
    breakpoint: 1800,
    cols: 6
  },
  large: {
    breakpoint: 1400,
    cols: 6
  },
  medium: {
    breakpoint: 1199,
    cols: 5
  },
  small: {
    breakpoint: 991,
    cols: 4
  },
  extraSmall: {
    breakpoint: 767,
    cols: 3
  },
  smallest: {
    breakpoint: 350,
    cols: 2
  }
};

export const GITHUB_URL = "https://github.com/victor-cordova/watchmo";



// WEBPACK FOOTER //
// ./src/constants.jsx